import { useState } from 'react';
import Heading from './components/Heading';
import Qualifications from './components/Qualifications';

export type TradeAllyListType = {
  tradeAllyId: string;
  tradeAllyName: string;
  stars: number;
  address: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  website: string;
  bbb: string;
  additionalInformation: string;
  brands: string[];
  products: never[];
  services: string[];
  reviews: {
    stars: number;
    review: string;
    name: string;
  }[];
  yearOfService: string;
  lastQualityInspection: string;
}[];

export type TabsType = {
  tabLogo: string;
  tabTitle: string;
  tabMessage: string;
};

type RecommendedContractorsCardType = {
  headingLogo: string;
  message: string;
  results: TradeAllyListType;
  tabs: TabsType[];
};

const RecommendedContractorsCard = ({
  headingLogo,
  message,
  results,
  tabs,
}: RecommendedContractorsCardType) => {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <>
      {results.length < 4 && (
        <div
          className="flex flex-col justify-between grow max-w-[366px]
       min-h-[503px] border border-gray-light rounded-md p-24 bg-gray-lighter m-18 sm:ml-18 sm:mr-11"
        >
          <Heading headingLogo={headingLogo} results={results} underFourResultsMessage={message} />
          <Qualifications tabs={tabs} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
        </div>
      )}
    </>
  );
};

export default RecommendedContractorsCard;
